module.exports = __webpack_public_path__ + "img/6.78e055bc.jpg";